import { add, isWithinInterval } from 'date-fns';
import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const storage = createJSONStorage<string | null>(() =>
  typeof window !== 'undefined' ? window.localStorage : (undefined as unknown as Storage),
);

const key = 'user-profile-locale-toast-shown-at';
const userProfileLocaleShownAt = atomWithStorage<string>(key, null, storage);

const REPEAT_AFTER_DAYS = 14;

export const userProfileLocaleNeedToShow = atom(
  async function getter(get) {
    const shownAt = get(userProfileLocaleShownAt);
    const now = new Date();
    const shownInMs = Date.parse(shownAt);
    const shownDate = Number.isNaN(shownInMs) ? null : new Date(shownInMs);
    const notShowBefore = add(shownDate, { days: REPEAT_AFTER_DAYS });

    const timeToShow =
      !shownDate || !isWithinInterval(now, { start: shownDate, end: notShowBefore });
    return timeToShow;
  },
  function setter(_get, set) {
    set(userProfileLocaleShownAt, () => new Date().toISOString());
  },
);
